import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import { connect } from "react-redux";
import PopupWrapper from "../components/PopupWrapper";
import AccountBackButton from "../components/AccountBackButton";
import AccountSubheader from "../components/AccountSubheader";
import { accountHomeViewActions } from "../_actions";
import moment from "moment";
import Spacer from "../components/Spacer";
import { Field, reduxForm, SubmissionError } from "redux-form";
import SuccessMessage from "../components/SuccessMessage";

class AccountDoNotDisturb extends Component {
  constructor(props) {
    super(props);
    let user = JSON.parse(localStorage.getItem("user"));
    if (!user.user_id) {
      user.user_id = user.dependant_user_id;
    }
    this.state = {
      submitSucceeded: false,
    };
    this.renderRadio = this.renderRadio.bind(this);

    this.props.dispatch(accountHomeViewActions.getDoNotDisturb(user));
  }

  renderField = (props) => {
    const {
      input,
      label,
      type,
      meta: { touched, error, warning },
    } = props;

    const inputStyles = css([
      styles.input,
      touched && error && styles.inputError,
    ]);
    return (
      <div>
        <label className={css(styles.label)}>{label}</label>
        <div>
          <input
            {...input}
            placeholder={label}
            type={type}
            className={inputStyles}
          />
          {touched &&
            ((error && <span className={css(styles.error)}>{error}</span>) ||
              (warning && <span>{warning}</span>))}
        </div>
      </div>
    );
  };

  renderRadio = (props) => {
    const {
      meta: { touched, error, warning },
    } = props;
    return (
      <span>
        <div className={css(styles.checkboxWrapper)}>
          <div className={css([styles.radio])}>
            <span
              className={css([
                styles.radioIcon,
                props.input.checked && styles.radioIconChecked,
              ])}
            />
          </div>
          <strong className={css([styles.label, styles.radioLabel])}>
            {props.label}
          </strong>
        </div>
        <input
          className={css(styles.hidden)}
          {...props.input}
          type={props.type}
        />
        {touched &&
          ((error && <span className={css(styles.error)}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </span>
    );
  };

  submit = (values) => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (!user.user_id) {
      user.user_id = user.dependant_user_id;
    }

    const obj = {
      status: values.status,
      start_time: values.start_time,
      end_time: values.end_time,
    };

    this.props.dispatch(
      accountHomeViewActions.setDoNotDisturb(user.user_id, obj)
    );
    this.setState({
      submitSucceeded: true,
    });
  };

  render() {
    const { handleSubmit, submit, submitFailed, submitSucceeded } = this.props;

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>
        <main className={css(styles.mainContainer)}>
          <AccountSubheader title="Do Not Disturb" />
          <h2 className={css(styles.label)}>Do Not Disturb</h2>
          <p className={css(styles.paragraphSmall)}>
            Enabling or scheduling Do Not Disturb means you will not receive any
            notifications
          </p>
          <Spacer />
          <form onSubmit={handleSubmit(this.submit)}>
            <label>
              <Field
                name="status"
                component={this.renderRadio}
                type="radio"
                value="DISABLED"
                label={"Disable Do Not Disturb"}
              />
            </label>
            <label>
              <Field
                name="status"
                component={this.renderRadio}
                type="radio"
                value="ENABLED"
                label={"Enable Do Not Disturb"}
              />
            </label>
            <label>
              <Field
                name="status"
                component={this.renderRadio}
                type="radio"
                value="SCHEDULED"
                label={"Schedule Do Not Disturb"}
              />
            </label>
            {this.props.accountHomeViewDoNotDisturb &&
              this.props.accountHomeViewDoNotDisturb.values.status ===
                "SCHEDULED" && (
                <div>
                  <Spacer />
                  <Field
                    name="start_time"
                    component={this.renderField}
                    label="Schedule start"
                    type="time"
                  />
                  <Field
                    name="end_time"
                    component={this.renderField}
                    label="Schedule end"
                    type="time"
                  />
                </div>
              )}
            <Spacer />
            <button type="submit" className={css(styles.buttonGreen)}>
              Save Do Not Disturb
            </button>
            {this.state.submitSucceeded && (
              <SuccessMessage message="Do Not Disturb mode saved" />
            )}
          </form>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const startDefault = new Date();
  startDefault.setMinutes(
    startDefault.getMinutes() - startDefault.getTimezoneOffset()
  );

  let numWeeks = 2;
  let endDefault = new Date();
  endDefault.setDate(endDefault.getDate() + numWeeks * 7);

  const initialValues = {
    status: state.accountHomeView.detail.status,
    start_time: state.accountHomeView.detail.start_time
      ? state.accountHomeView.detail.start_time
      : "00:00",

    end_time: state.accountHomeView.detail.end_time
      ? state.accountHomeView.detail.end_time
      : "00:00",
  };

  return {
    initialValues,
    ...state.form,
    // ...state
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "accountHomeViewDoNotDisturb",
    enableReinitialize: true,
  })(AccountDoNotDisturb)
);
